"use strict";import{ColorHandle as e}from"./src/ColorHandle.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-color-handle",e);
//# sourceMappingURL=sp-color-handle.js.map
